















import {Component, Vue, Prop} from 'vue-property-decorator'
import {InputText} from 'simpli-web-sdk'
import {PanelUser} from '@/model/resource/PanelUser'

@Component({
  components: {InputText},
})
export default class InputDocumentPanelUser extends Vue {
  @Prop({type: Object, required: true}) model!: PanelUser
  valid = true

  get isDisabled() {
    return this.model.idPanelUserPk !== 0
  }

  validateDocument() {
    if (this.model.document && !this.isDisabled) {
      this.valid =
        this.model.document.length < 255 && this.model.document.length > 0
      this.$emit('inputDocument')
    }
  }
}
